import { ActionTree } from 'vuex';
import { setupApollo } from '../../../lib/apollo_setup';
import { JobState, JobPostMutationInput } from './types';
import { CREATE_JOB_POST } from '@/graphql/job_post/mutations';

const apolloProvider = setupApollo();
export const actions: ActionTree<JobState, any> = {
  async createJobPost(_, jobPostMutationInput: JobPostMutationInput) {
    const apolloClient = apolloProvider.defaultClient;

    try {
      const response = await apolloClient.mutate({
        mutation: CREATE_JOB_POST,
        variables: {
          jobInput: {
            title: jobPostMutationInput.title,
            description: jobPostMutationInput.description,
            ageGroups: jobPostMutationInput.ageGroups,
            careType: jobPostMutationInput.careType,
            requirements: jobPostMutationInput.requirements,
            responsibilities: jobPostMutationInput.responsibilities,
            languages: jobPostMutationInput.languages,
            location: jobPostMutationInput.location,
            numberOfChildren: jobPostMutationInput.numberOfChildren,
            paymentRate: jobPostMutationInput.paymentRate,
            schedule: jobPostMutationInput.schedule,
            aiGenerated: jobPostMutationInput.aiGenerated,
          } satisfies JobPostMutationInput,
        },
      });

      return response;
    } catch (error) {
      console.error('Network error creating job post:', error);
      throw error;
    }
  },
};

export default actions;
